﻿import type { Dispatch } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';
import type { Token } from '../@types/Token';

import { refreshAccessToken } from '../actions/auth';
import type { RootState } from '../reducers';

const isExpired = (token: string, offset: number) => {
  try {
    const data = jwtDecode<Token>(token);
    const expires = new Date(data.exp * 1000 - offset);

    return expires <= new Date();
  } catch (_e) {
    return true;
  }
};

export const getTokenEmail = (token: string) => {
  if (!token) {
    return null;
  }

  const data = jwtDecode<Token>(token);
  return data?.email || null;
};

const requestTokenRenewal = (dispatch: Dispatch, getState: () => RootState) => {
  const { auth } = getState();
  if (auth.token) {
    if (isExpired(auth.token, 9 * 60 * 1000)) {
      refreshAccessToken()(dispatch);
    }
  }
};

export const createRefreshTokenHandler = (dispatch: Dispatch, getState: () => RootState) => {
  setInterval(
    () => {
      requestTokenRenewal(dispatch, getState);
    },
    3 * 60 * 1000,
  );
};
